import React from 'react';
import Section from './Section'
import './App.css';
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import { Button, Collapse } from 'antd/lib';
import 'antd/dist/antd.css';

const { Panel } = Collapse;

class TakenCourse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            showModal: false,
            showAlert: false,
            showAddedAlert: false,
            requiredCourses: ''
        }
    }
    rate() {
        this.props.rate(this.props.data.name)
    }
    getHistory(){
        return (
            <span style={{'fontWeight': 'normal'}}>
              {this.props.data.history}
            </span>
          )
    }
    render() {

        return (

            <Collapse bordered={true} activeKey={false}>
                <Panel
                    style={{ 'fontWeight': 'bold', "boxShadow": '0 0px 3px rgba(192,192,192,0.05), 0 3px 6px rgba(0,0,0,0.23)', 'marginBottom': '10px' }}
                    header={this.props.data.number + ": " + this.props.data.name}
                    extra={this.getCourseButton()}
                    showArrow={false}
                >
                    {this.getHistory()}
                    <br></br>
                </Panel>
            </Collapse>
        )
    }

    getCourseButton() {
        let buttonVariant = 'dark';
        let buttonOnClick = () => this.rate();
        let buttonText = 'Rate Course';

        return (
            <Button variant={buttonVariant} style={{zIndex:100}}onClick={buttonOnClick}>
                {buttonText}
            </Button>
        )
    }
}

export default TakenCourse;
